module.exports = __webpack_public_path__ + "static/media/cross-white.5fc48b2a.svg";